import React, { useEffect, useRef, useState } from 'react'
import Toggle from 'particles/Toggle'
import Text, { TextScale } from 'particles/Text'
import { menuItemClasses } from '@mui/material/MenuItem'
import styled from 'particles/themes/styled'
import { BaseMenuItemProps, MenuItemSize } from '.'
import { StyledBaseMenuItem } from './style'
import Tooltip from 'particles/Tooltip'
import IconButton from 'particles/Button/IconButton'

const sizeMap: Record<MenuItemSize, { textScale: TextScale }> = {
    m: {
        textScale: 'bodyM400',
    },
    s: {
        textScale: 'bodyS400',
    },
}

interface MenuItemProps extends BaseMenuItemProps {
    text: string
}

const StyledMenuItem = styled(StyledBaseMenuItem)`
    &.${menuItemClasses.root} {
        padding: 6px 4px;
        align-self: stretch;
        @media screen and (max-width: 768px) {
            min-height: auto;
        }
        &.${menuItemClasses.focusVisible} {
            border: 3px solid ${({ theme }) => theme.colors.border.actionFocus};
            padding: 3px 1px;
            background-color: transparent;
        }
        .text {
            flex: 1 0 0;
            white-space: pre-wrap;
        }
    }
`

const MenuItemToggle: React.FC<MenuItemProps> = ({
    text,
    tooltipContext,
    isDisabled,
    size = 's',
    selected = false,
    ...props
}) => {
    const { textScale } = sizeMap[size]
    const labelRef = useRef<HTMLDivElement>(null)
    // This will be use to calculate alignItems
    const [offsetHeight, setOffsetHeight] = useState(labelRef.current?.offsetHeight)

    useEffect(() => {
        setOffsetHeight(labelRef.current?.offsetHeight)
    }, [labelRef.current?.offsetHeight])

    return (
        <StyledMenuItem
            {...props}
            disabled={isDisabled}
            disableRipple
            containerHeight={offsetHeight}
            textScale={textScale}
        >
            <Toggle size={size} isChecked={selected} isDisabled={isDisabled} />
            <Text ref={labelRef} scale={textScale} className="text">
                {text}
            </Text>
            {isDisabled && (tooltipContext?.label || tooltipContext?.title) && (
                <Tooltip {...tooltipContext} onClick={e => e.stopPropagation()}>
                    <IconButton size="xs" color="neutral" form="icon" icon="question" className="tooltip" />
                </Tooltip>
            )}
        </StyledMenuItem>
    )
}

export default MenuItemToggle
